import { addDays, format, getDay } from 'date-fns';
import type { Locale } from 'date-fns';

type InstantOptions = {
  locale?: Locale;
};

/**
 * Instants keep their offset, so they are read in the shopper's timezone.
 */
export function formatInstantDate(
  date: Date,
  formatString: string,
  { locale }: InstantOptions = {},
): string {
  return format(date, formatString, { locale });
}

export function getInstantDayOfWeek(date: Date): number {
  return getDay(date);
}

export function addInstantDays(date: Date, amount: number): Date {
  return addDays(date, amount);
}
